import React, { createContext, useCallback, useReducer, useEffect, useState } from 'react';
import localStorageSafe from 'zach-local-storage-safe';
import _ from 'lodash';
import * as firebaseApp from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';

const firebase = firebaseApp.initializeApp({
    apiKey: 'AIzaSyDBxx4lyOoBJDpKlLS7ye_IomI1O4UVsME',
    authDomain: 'project-id.firebaseapp.com',
    appID: '1:571377425932:web:f7a9159544dcfbffc2d829'
});

// firebase.auth().currentUser.getIdToken(true).then((idTokern) => {
//     console.log(idTokern);
// });
const Context = createContext({});

const signInWithEmailAndPassword = (setAccessToken, setUser) => ({ email, password }) => {
    firebase
        .auth()
        .signInWithEmailAndPassword(email, password)
        .then((res) => {
            const user = firebase.auth().currentUser;
            setUser(user);
            user.getIdToken(false).then((token) => {
                setAccessToken(token);
            });
        })
        .catch((err) => {
            console.log(err, 'err');
        });
};

const updateProfile = (user) => (data) => {
    try {
        user.updateProfile(data).then(function (){});
    } catch (err) {
        console.log(err);
    }
};
const sendEmailVerification = (user) => ({ email }) => {
    try {
        user.sendEmailVerification().then(() => {
            console.log('send');
        });
    } catch (err) {
        console.log(err);
    }
};
const createUserWithEmailAndPassword = () => ({ email, password }) => {
    try {
        firebase.auth().createUserWithEmailAndPassword(email, password);
    } catch (err) {
        console.log(err);
    }
};

const signOut = () => () => {
    try {
        firebase.auth().signOut();
    } catch (err) {
        console.log(err);
    }
};
const providerData = (user) => () => {
    try {
        user.providerData.forEach(function (profile){
            console.log('Sign-in provider: ' + profile.providerId);
            console.log('  Provider-specific UID: ' + profile.uid);
            console.log('  Name: ' + profile.displayName);
            console.log('  Email: ' + profile.email);
            console.log('  Photo URL: ' + profile.photoURL);
        });
    } catch (err) {}
};
const reducer = (state, action) => {
    const { name, payload, actionType } = action;
    switch (actionType) {
        default:
            return state;
    }
};

const initState = {
    data: localStorageSafe.getItem('eventData', 'object'),
    condition: { error: { message: null } }
};
export const Provider = (props) => {
    const [ state, dispatch ] = useReducer(reducer, initState);
    const [ user, setUser ] = useState({});
    const [ accessToken, setAccessToken ] = useState('');

    const signInWithEmailAndPasswordAction = useCallback(signInWithEmailAndPassword(setAccessToken, setUser), [ setAccessToken, setUser ]);
    const sendEmailVerificationAction = useCallback(sendEmailVerification(user), [ user ]);
    const updateProfileAction = useCallback(updateProfile(user), [ user ]);
    const createUserWithEmailAndPasswordAction = useCallback(createUserWithEmailAndPassword(), []);
    const signOutAction = useCallback(signOut(), []);
    useEffect(
        () => {
            signInWithEmailAndPasswordAction({ email: 'flyboring@gmail.com', password: 'Ru1735' });
        },
        [ signInWithEmailAndPasswordAction ]
    );

    const _onLoad = useCallback((data = {}) => {
        const { pathname, actionType } = data;
        switch (pathname) {
            default:
                break;
        }
        switch (actionType) {
            default:
                break;
        }
    }, []);
    const _onChange = useCallback((e, data) => {
        switch (data.actionType) {
            default:
                break;
        }
    }, []);

    return <Context.Provider value={{ state, onChange: _onChange, onLoad: _onLoad }}>{props.children}</Context.Provider>;
};

export const withContext = (Componet) => (props) => {
    return (
        <Provider>
            <Componet {...props} />
        </Provider>
    );
};

export default Context;
